package top.wcpe.allincore.ui.runtime.internal.math

import kotlin.math.round

/** JS：双精度乘加后按 1e10 粒度舍入，消除十进制噪声（常见 step 精度下与 JVM BigDecimal 一致）。 */
internal actual fun decimalStepAlign(stepValue: Double, steps: Long, minValue: Double): Double {
    val raw = stepValue * steps + minValue
    if (!raw.isFinite()) return raw
    return round(raw * 1e10) / 1e10
}
